import { Backdrop, Button, TextField } from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import { Vid } from "../../types/skills";

import { SkillTemplate } from "../../src/API";

export default function ExternalVideoSelector({
  open,
  setOpen,
  extVid,
  setExtVid,
  onSelected,
}: {
  open: boolean;
  setOpen: (state: boolean) => void;
  extVid: Vid;
  setExtVid: (v: Vid) => void;
  onSelected: () => Promise<Partial<SkillTemplate>>;
}) {
  return (
    <Backdrop
      sx={{
        alignItems: "flex-start",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        paddingTop: "4rem",
        paddingBottom: "4rem",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        overflow: "auto",
      }}
      open={open}
    >
      <div
        className="bg-white p-8 rounded-md grid gap-4 items-center"
        style={{ gridTemplateColumns: "1fr 3fr" }}
      >
        <h2
          className="text-center font-head"
          style={{ gridColumn: "1 / span 2" }}
        >
          ADD EXTERNAL VIDEO
        </h2>
        <label>Title</label>
        <TextField
          required
          value={extVid.title}
          onChange={(e) => setExtVid({ ...extVid, title: e.target.value })}
          variant="outlined"
          sx={{
            width: "100%",
          }}
          size="small"
        />
        <label>Embed Link</label>
        <TextField
          required
          value={extVid.url}
          onChange={(e) => setExtVid({ ...extVid, url: e.target.value })}
          variant="outlined"
          sx={{
            width: "100%",
          }}
          size="small"
        />
        <label>Description</label>
        <TextField
          required
          value={extVid.description}
          onChange={(e) =>
            setExtVid({ ...extVid, description: e.target.value })
          }
          variant="outlined"
          sx={{
            width: "100%",
          }}
          size="small"
          multiline
        />
        <div
          className="justify-center flex gap-4"
          style={{ gridColumn: "1 / span 2" }}
        >
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            size="small"
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            endIcon={<SaveOutlinedIcon />}
            disabled={!extVid.url}
            variant="contained"
            color="secondary"
            onClick={onSelected}
            size="small"
          >
            Save
          </Button>
        </div>
      </div>
    </Backdrop>
  );
}
